<template>
  <div class="discover flex flex-column flex-1">
    <u-header show-back>忘记密码</u-header>
    <div class="scrollable container flex-1 flex flex-row">
      <form name="form" class="flex-1" @submit.prevent="forget">
        <u-input type="email" class="form-control" placeholder="请输入您的邮箱" v-model="email" autofocus tabindex="1">
          <span v-if="submitted&&validation.hasError('email')" slot="right" class="input-error">{{validation.firstError('email')}}</span>
        </u-input>
        <u-button native-type="submit" style="margin-top: 40px">重置密码</u-button>
      </form>
      <p class="tip">如果您没有绑定邮箱，请联系管理员来重置密码</p>
    </div>
  </div>
</template>
<script>
import { Validator } from 'simple-vue-validator'
import AV from 'leancloud-storage'
export default {
  data () {
    return {
      email: '',
      submitted: false
    }
  },
  validators: {
    email: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('邮箱必填').email('请输入有效的邮箱地址')
      }
    }
  },
  methods: {
    forget () {
      this.submitted = true
      this.$validate().then(isSuccess => {
        if (isSuccess) {
          AV.User.requestPasswordReset(this.email).then(() => {
            this.$toast('请打开邮箱查看重置密码邮件')
            this.$router.go(-1)
          }).catch(error => {
            this.$toast(err.message || '未知错误')
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// ForgetPassword.vue?4de8d68e